import { useCallback } from 'react';
import ReactPaginate from 'react-paginate';

import Icon from './Icon';

function Pagination({ data, onChange }) {
  const { currentPage = 1, totalPages } = data;

  const onPageChange = useCallback(
    (page) => {
      let newPage = page.selected + 1;
     /* try {
        window.scroll({
          top: 0,
          left: 0,
        });
      } catch (error) {
        window.scrollTo(0, 0);
      }*/
      onChange(newPage);
    },
    [onChange]
  );

  return (
    <div className="pagination">
      <ReactPaginate
        pageCount={totalPages}
        forcePage={currentPage - 1}
        onPageChange={onPageChange}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        previousLabel={<Icon type="arrow-left" />}
        nextLabel={<Icon type="arrow-right" />}
        containerClassName="pagination-container"
        pageClassName="page"
        previousClassName="arrow"
        nextClassName="arrow"
        activeClassName="active-page"
        disabledClassName="disabled-arrow"
      />
      <style jsx>{`
        .pagination {
          margin-top: var(--margin-md);
          display: flex;
          justify-content: flex-start;
        }
        :global(.pagination-container) { 
          display: flex;
        }
        :global(.page) {
          margin: 0 8px;
          cursor: pointer;
        }
        :global(.arrow) {
          cursor: pointer;
        }
        :global(.active-page) {
          color: var(--primary);
          cursor: default;
        }
        :global(.disabled-arrow) {
          color: var(--grey-light);
          cursor: default;
        }
        @media all and (max-width: 768px){
          .pagination {
            margin-top: var(--margin-md);
            display: flex;
            justify-content: flex-start;
          }
        }
      `}</style>
    </div>
  );
}

export default Pagination;
